import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import { ROUND_SELECT, SET_AUTO_SWITCH } from '../actions/round';
import oget from 'oget';

const defaultState = {
  autoSwitch: true,
  selectionDate: new Date(0),
  expectedId: null,
  expectedCategories: null,
  finished: false,
};

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case SET_AUTO_SWITCH: {
      return {
        ...state,
        ...payload,
      };
    }

    case ROUND_SELECT: {
      return {
        selectionDate: new Date(),
        expectedId: payload.round.externalId,
        expectedCategories: payload.categories,
        finished: false,
      };
    }

    case CONTESTS_SHOW_SUCCESS: {
      if (state.expectedId === null) {
        return {
          ...state,
          expectedId: null,
          expectedCategories: null,
          finished: true,
        };
      }

      if (state.expectedId === oget(payload, 'selectedRound.externalId', null)) {
        return {
          ...state,
          expectedId: null,
          expectedCategories: null,
          finished: true,
        };
      }

      return {
        ...state,
        expectedId: state.expectedId,
        expectedCategories: state.expectedCategories,
        finished: false,
      };
    }

    default: {
      return state;
    }
  }
};
